'use client';

import { Suspense } from 'react';

import { TradingLeaderboardPage } from '@flipster/features/src/trading-leaderboard-page';

const Page = () => {
  return (
    <Suspense>
      <TradingLeaderboardPage />
    </Suspense>
  );
};

export default Page;
